module.exports = __webpack_public_path__ + "static/fonts/fontello.36d4af8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/fontello/font/fontello.woff?32974303
// module id = V7UM
// module chunks = 25